module.exports = __webpack_public_path__ + "media/share_images/violin-f5ce427f.svg";